module.exports = __webpack_public_path__ + "media/public/images/about/experts/nauka_tretyak-0710069ce135779c19bfcc0ffb755ec9.svg";